<div class="validation-error-container">
  <div class="validation-error" *ngIf="show && !valid">
    <i-feather name="alert-circle"></i-feather>
    <span class="message" [innerHTML]="invalidMsg"></span>
  </div>
</div>
